import { first, isEmpty } from 'lodash';

// create choices
export const CONTACTS_CREATE_CHOICES = {
  CSV: 'csv',
  EXISTING: 'existing',
};


export const CONTACT_ERRORS = {
  DUPLICATE: 'duplicate',
  DUPLICATE_ON_SEQUENCE: 'duplicate_on_sequence',
  BLACKLISTED: 'blacklisted',
  BOUNCED: 'bounced',
  EMPTY_OUTLET_NAME: 'empty_outlet_name',
  INVALID: 'invalid',
  VARIABLE_ERROR: 'variable_error',
};

export const EMAIL_VALIDATION_STATUS = {
  VALID: 'valid',
  INVALID: 'invalid',
  ACCEPT_ALL: 'accept_all',
  DISPOSABLE: 'disposable',
  UNKNOWN: 'unknown',
};

export const EMAIL_VALIDATION_STATUS_LABEL = {
  VALID: 'Valid',
  INVALID: 'Invalid',
  RISKY: 'Risky',
  UNKNOWN: 'Unknown ',
};

export const DUPLICATES = 'duplicates';
export const DUPLICATES_BY_ACCOUNT = 'duplicates_by_account';

export const CSV_LIST_FIELDS = ['industries'];

export const CUSTOM_FIELD_MAX_LENGTH = 1000;

export const CONTACT_STATUSES = {
  opened: 'opened',
  sent: 'sent',
  delivered: 'delivered',
  bounced: 'bounced',
  finished: 'finished',
  marked_as_finished: 'manually_finished',
  do_not_contact: 'blacklisted',
  variableError: 'variable_error',
};

export const CONTACT_DELIVERY_STATUS_CONFIG = {
  [CONTACT_STATUSES.opened]: {
    label: 'Opened',
    has_status: contact => (
      !isEmpty(contact.outreaches) && !isEmpty(first(contact.outreaches).status_opened_date)
    ),
  },
  [CONTACT_STATUSES.sent]: {
    label: 'Sent',
    has_status: contact => (
      !isEmpty(contact.outreaches) && !isEmpty(first(contact.outreaches).status_sent_date)
    ),
  },
  [CONTACT_STATUSES.delivered]: {
    label: 'Delivered',
    has_status: contact => (
      !isEmpty(contact.outreaches) && !isEmpty(first(contact.outreaches).status_delivered_date)
    ),
  },
  [CONTACT_STATUSES.bounced]: {
    label: 'Bounced',
    has_status: contact => !isEmpty(contact.status_bounced_date),
  },
  [CONTACT_STATUSES.finished]: {
    label: 'Finished',
    has_status: contact => !isEmpty(contact.status_finished_date),
  },
  [CONTACT_STATUSES.marked_as_finished]: {
    label: 'Marked as finished',
    has_status: contact => !isEmpty(contact.status_manually_finished_date),
  },
  [CONTACT_STATUSES.do_not_contact]: {
    label: 'Do not contact',
    has_status: contact => (
      !isEmpty(contact.errors) && first(contact.errors).error_type === CONTACT_STATUSES.do_not_contact
    ),
  },
  [CONTACT_STATUSES.variableError]: {
    label: 'Missing Variables',
    has_status: contact => (
      !isEmpty(contact.errors) && contact.errors.some(err => err.error_type === CONTACT_STATUSES.variableError)
    ),
  },
};

export const HEADERS_SECTION = 'headers'; // name for redux-form section in order to group dynamic headers

export const CONTACT_BASIC_FIELDS = [
  'first_name',
  'last_name',
  'email',
  'outlet.name',
  'title',
  'subject',
  'outlet.website',
  'outlet.outlet_type',
];

export const CONTACT_OTHER_FIELDS = [
  'outlet.unique_monthly_visitors',
  'outlet.audience',
  'outlet.country',
  'outlet.dma',
  'outlet.alexa_score',
];

export const CONTACT_CUSTOM_FIELDS = [
  'Competitor',
  'Keyword',
  'Other',
  'Custom1',
  'Custom2',
  'Custom3',
];
